/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_subjects_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Nedostal jsem správný produkt.`
};

const da_contact_subjects_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Jeg har modtaget det forkerte produkt.`
};

const de_contact_subjects_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Ich habe das falsche Produkt erhalten.`
};

const en_contact_subjects_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `I did not receive the correct product.`
};

const es_contact_subjects_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `No he recibido el producto correcto.`
};

const fr_contact_subjects_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Je n'ai pas reçu le bon produit.`
};

const hu_contact_subjects_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Nem a megfelelő terméket kaptam meg.`
};

const it_contact_subjects_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Ho ricevuto il prodotto sbagliato.`
};

const nl_contact_subjects_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Ik heb het verkeerde product ontvangen.`
};

const pl_contact_subjects_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Otrzymałem zły produkt.`
};

const pt_contact_subjects_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Recebi o produto errado.`
};

const sv_contact_subjects_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Jag har fått fel produkt.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_subjects_wrong_product = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_subjects_wrong_product(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_subjects_wrong_product", locale)
	if (locale === "cs") return cs_contact_subjects_wrong_product(inputs)
	if (locale === "da") return da_contact_subjects_wrong_product(inputs)
	if (locale === "de") return de_contact_subjects_wrong_product(inputs)
	if (locale === "en") return en_contact_subjects_wrong_product(inputs)
	if (locale === "es") return es_contact_subjects_wrong_product(inputs)
	if (locale === "fr") return fr_contact_subjects_wrong_product(inputs)
	if (locale === "hu") return hu_contact_subjects_wrong_product(inputs)
	if (locale === "it") return it_contact_subjects_wrong_product(inputs)
	if (locale === "nl") return nl_contact_subjects_wrong_product(inputs)
	if (locale === "pl") return pl_contact_subjects_wrong_product(inputs)
	if (locale === "pt") return pt_contact_subjects_wrong_product(inputs)
	return sv_contact_subjects_wrong_product(inputs)
};
export { contact_subjects_wrong_product as "contact.subjects.wrong_product" }